"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Party = /** @class */ (function () {
    function Party() {
    }
    return Party;
}());
exports.default = Party;
;
//# sourceMappingURL=Party.js.map